import React, { useState, useEffect, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux'



import './LangSet.css'

import {
    Link,
    NavLink
} from "react-router-dom";

 import { SET_LANG } from '../../redux/reducers/site';

export default function LangSet(props){

    const dispatch = useDispatch();
    const folder = useSelector((state) => state.site.setup.folder);
    
    const flags = [
        {lang:'ru', url:`${folder}/svg/flags/ru.svg`, alt:'RU'},
        /*--{lang:'en', url:`${folder}/svg/flags/en.svg`, alt:'EN'},
        
        a{lang:'de', url:'/svg/flags/de.svg', alt:'DE'},
        {lang:'fr', url:'/svg/flags/de.svg', alt:'FR'},
        {lang:'it', url:'/svg/flags/de.svg', alt:'IT'}
        --*/
        
        
    ]

    var qstr = window.location.toString();
    let url = new URL(qstr);
    let ltmp= url.pathname.split('/');
    
    // Get current language from path (index 2) or use the active language prop
    // Если язык явно не указан - используем 'ru' по умолчанию
    let currentLang = props.active || ltmp[2];
    if (!currentLang || !['ru', 'en', 'de'].includes(currentLang)) {
        currentLang = 'ru';
    }
    
    var path1 = ltmp[3] ? '/'+ltmp[3] : '';
    var path2 = ltmp[4] ? '/'+ltmp[4] : '';
    var path3 = ltmp[5] ? '/'+ltmp[5] : '';
    let path = path1+path2+path3;

return(
    <ul className='flags'>
    {
        flags.map((i, key) => 
            <li key={key} className={props.active===i.lang?'active':null}>
                <Link to={i.lang+path}><img src={i.url} alt={i.alt} title={i.alt} height='15'/></Link>
            </li>
        )
    }
    </ul>
)
function setLang(lang){
    dispatch( SET_LANG(lang));
}
}